import React, { useEffect } from 'react'
import { useState } from 'react';
import { useRef } from 'react';
import Carousel from "react-multi-carousel";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import useStateRef from 'react-usestateref';
import { DEFAULT_IMAGE_140 } from '../../middleware/types';

const TeacherResourcesCarousel = (props) => {
    const [domainName, setdomainName, domainNameRef] = useStateRef(props.domainName)
    const [recommendedData, setRecommendedData] = useState(props?.carouselData && props.carouselData.length > 0 ? props.carouselData : "")
    const carouselRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [count, setCount] = useState();
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef()



    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5,
            partialVisibilityGutter: recommendedData && recommendedData.length <= 5 ? 0 : 20
        },
        desktop: {
            breakpoint: { max: 3000, min: 1023 },
            items: 5,
            partialVisibilityGutter: recommendedData && recommendedData.length <= 5 ? 0 : 20
        },
        tablet: {
            breakpoint: { max: 1023, min: 464 },
            items: 1,

        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,

        },
    };


    const handlePrevious = () => {
        setCurrentSlide(currentSlide - 1);
        carouselRef.current.previous();
    };

    const handleNext = () => {
        setCurrentSlide(currentSlide + 1);
        carouselRef.current.next();
    };
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;

    }




    const handleQuickViewProductPage = (id, count) => {

        const productId = id;
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res !== null) {
                    var productDetatils = (JSON.parse(res.response)).response
                    props.quickviewCallback(productDetatils)
                    props.solrValue(count)
                    var modalElement = document.getElementById(`${productId ? productId : "quickViewModal"}`);
                   
                    var bootstrapModal = new bootstrap.Modal(modalElement);
                   
                    bootstrapModal.show();
                    

                }
            })
    }
    useEffect(() => {
        setScreenWidth(screen.width)
    }, [])

    useEffect(() => {
        if (screenWidthRef.current < 1024 && recommendedData && recommendedData.length > 2) {
           
            if (document.querySelector("#recommendednextButton")) {
                const sliderButton = document.querySelector("#recommendednextButton");
                sliderButton.click();
            }
        }


    }, [screenWidthRef.current])

    return (
        <div className="">
            {recommendedData ? <div className={`${screenWidthRef.current >= 1024 && recommendedData.length <= 5 ? "recommendedMargin" : ""} recommended row teacherCarousel border-0 pdp-detail-moreinfo recommendedPadding`}>
                <div className="px-0">
                    <div className={`${screenWidthRef.current < 1023 || recommendedData.length <= 5 ? "d-block" : "d-none"} px-0 youTextSize${screenWidthRef.current > 1024 || recommendedData.length <= 5 ? "justify-content-between" : "justify-content-center"}`}>
                        {screenWidthRef.current >= 1024 ? <h2 className={`${recommendedData.length <= 5 ? "justify-content-between" : "justify-content-center"} d-flex  youTextSize`}>You May Also Like</h2> : ""}
                        <h2 className={`${screenWidthRef.current < 1024 ? "justify-content-center d-flex" : "d-none"}  `}>You May Also Like</h2>

                        <div className={`${recommendedData.length > responsive.desktop.items == true ? "d-none" : "d-none"} my-auto `}>
                            <button id="recommendedpreviousButton" className={`cb-previous-button mx-4 ${currentSlide === 0 ? 'disabled' : ''}`} onClick={handlePrevious} >
                                <svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
                            </button>
                            <button id="recommendednextButton" className={`cb-next-button ${currentSlide >= parseInt(recommendedData.length - responsive.desktop.items) ? 'disabled' : ''}`} onClick={handleNext} >
                                <svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
                            </button>
                        </div>
                    </div>
                </div>
                {screenWidthRef.current >= 1024 ?
                    <Carousel
                        ref={carouselRef}
                        swipeable={true}
                        draggable={true}
                        showDots={false}
                        responsive={responsive}
                        ssr
                        arrows={true}
                        infinite={false}
                        customLeftArrow={<button className={`${recommendedData.length == 5 ? "d-none" : ""} customLeftArrow`}><h2 className=' ymalTextPosition youTextSize'>You May Also Like</h2> <button className={`cb-previous-button mx-4 ymalPreviousButtonPosition`} >
                            <svg className='cb-caret-previous' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" /></svg>
                        </button></button>}
                        customRightArrow={<button className={`cb-next-button ymalnextButtonPosition ${recommendedData.length == 5 ? "d-none" : ""} `} >
                            <svg className='cb-caret-next' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 256 512"><path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" /></svg>
                        </button>}
                        autoPlay={false}
                        renderArrowsWhenDisabled={true}
                        partialVisible={true}
                        autoPlaySpeed={0}
                        keyBoardControl={true}
                        transitionDuration={200}
                        removeArrowOnDeviceType={['']}
                        deviceType="desktop"
                        className='custom-carousel'
                        itemClass="custom-item-class"

                    >
                        {recommendedData.map((value, key) => {
                            return (
                                <div className={`m-auto row mb-1 cb-product-item-sty`} style={{ overflow: key === 5 ? 'hidden' : 'visible' }} >
                                    <div key={key} className="">
                                        <div className="c-feature-product qv-model mb-0">
                                            <a className='w-100 cb-product-link' href={value && value.productDisplayGrid && value.productDisplayGrid.productUrl}>
                                                <div className='d-flex'>
                                                    <img loading="lazy" width="140px" height="140px" onError={replaceImage} alt="/images/fpo/product-140x140.gif" src={domainNameRef.current.concat(value && value.productDisplayGrid && value.productDisplayGrid.imageURL)} />
                                                </div>
                                                <h3 className=" my-2 cb-categoryName-title" dangerouslySetInnerHTML={{ __html: value && value.productDisplayGrid.displayName }}></h3>
                                            </a>
                                            <p class="c-product-total">{value.productDisplayGrid && value.productDisplayGrid.activeFlagCount && value.productDisplayGrid.activeFlagCount != 0 ? value.productDisplayGrid.activeFlagCount + " Products" : "Item #".concat(value?.relatedProductId)}</p>

                                            {value.productDisplayGrid && value.productDisplayGrid.hidePrice && value.productDisplayGrid.hidePrice == "true" ? <p class="c-product-price">Call For Pricing</p>
                                                : <>{value && value.productDisplayGrid && value.productDisplayGrid.salePrice && value.productDisplayGrid.salePrice != "$0.00" ?
                                                <p class="c-product-price-affer">
                                                    <del><span class="c-product-old-price">{value.productDisplayGrid.basePrice}</span></del> <span class="c-product-price-value">{value.productDisplayGrid.salePrice}</span></p> :
                                                    value && value.productDisplayGrid && value.productDisplayGrid.itemPrice && value.productDisplayGrid.itemPrice != "$0.00" ? <p className="my-0 c-product-price">{value && value.productDisplayGrid.itemPrice ? value.productDisplayGrid.itemPrice : ""}</p> : ""}
                                                    {value && value.productDisplayGrid && value.productDisplayGrid.priceRangeForFamily && value.productDisplayGrid.priceRangeForFamily.itemPrice ? <p className="my-0 c-product-price">{value && value.productDisplayGrid.priceRangeForFamily && value.productDisplayGrid.priceRangeForFamily.itemPrice}</p> : ""}
                                                    {value && value.productDisplayGrid && value.productDisplayGrid.retailPrice && value.productDisplayGrid.retailPrice != "$0.00" ?
                                                        <p class="c-retail-label">
                                                            {`Retail `}
                                                            <del><span>{value && value.productDisplayGrid && value.productDisplayGrid.retailPrice}</span></del>
                                                        </p> : value?.productDisplayGrid?.priceRangeForFamily?.retailPrice && value?.productDisplayGrid?.priceRangeForFamily?.retailPrice != "$0.00" ? <p class="c-retail-label">
                                                            {`Retail `}
                                                            <del><span>{value.productDisplayGrid.priceRangeForFamily.retailPrice}</span></del>
                                                        </p>:""}
                                                </>}
                                            {value.productDisplayGrid && value.productDisplayGrid.reviewURLAverage ?
                                                <div className="c-product-rating">

                                                    <img loading="lazy" src={domainNameRef.current.concat(`/images/stars/50/rating-${value.productDisplayGrid.reviewURLAverage}_50.png`)} alt="rating" />

                                                </div> : ""}

                                            {value.productDisplayGrid && value.productDisplayGrid.hidePrice && value.productDisplayGrid.hidePrice == "false" && value.productDisplayGrid.qtyDiscountAvailable && value.productDisplayGrid.qtyDiscountAvailable == true || value?.productDisplayGrid?.priceRangeForFamily?.qtyDiscount == true ?
                                                <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
                                            <p id="recommendedQuickView" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></p>
                                            <button className='btn quick-btn modal-link' onClick={() => handleQuickViewProductPage(value.productDisplayGrid.productId, value.productDisplayGrid.activeFlagCount)}>Quick View</button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel> : <Carousel
                        ref={carouselRef}
                        swipeable={true}
                        draggable={true}
                        showDots={false}
                        responsive={responsive}
                        ssr
                        infinite={false}
                        autoPlay={false}
                        autoPlaySpeed={0}
                        keyBoardControl={true}
                        transitionDuration={200}
                        removeArrowOnDeviceType={['desktop']}
                        deviceType="desktop"
                        className='custom-carousel'
                        itemClass="custom-item-class"
                        centerMode={true}

                    >{recommendedData.map((value, key) => {
                        return (
                            <div className="m-auto row mt-4 mb-5 cb-product-item-sty" style={{ overflow: key === 5 ? 'hidden' : 'visible' }} >
                                <div key={key} className="">
                                    <div className="c-feature-product qv-model mb-0">
                                        <a className='w-100 cb-product-link' href={value && value.productDisplayGrid && value.productDisplayGrid.productUrl}>
                                            <div className=''>
                                                <img loading="lazy" width="140px" height="140px" onError={replaceImage} alt="/images/fpo/product-140x140.gif" src={domainNameRef.current.concat(value && value.productDisplayGrid && value.productDisplayGrid.imageURL)} />
                                            </div>
                                            <h3 className=" my-2 cb-categoryName-title" dangerouslySetInnerHTML={{ __html: value && value.productDisplayGrid && value.productDisplayGrid.displayName }}></h3>
                                        </a>
                                        <p class="c-product-total">{value.productDisplayGrid && value.productDisplayGrid.activeFlagCount && value.productDisplayGrid.activeFlagCount != 0 ? value.productDisplayGrid.activeFlagCount + " Products" : "Item #".concat(value.productDisplayGrid.productId)}</p>
                                        {value.productDisplayGrid && value.productDisplayGrid.hidePrice && value.productDisplayGrid.hidePrice == "true" ? <p class="c-product-price">Call For Pricing</p> : <>
                                        {value && value.productDisplayGrid && value.productDisplayGrid.salePrice && value.productDisplayGrid.salePrice != "$0.00" ?
                                                <p class="c-product-price-affer">
                                                    <del><span class="c-product-old-price">{value.productDisplayGrid.basePrice}</span></del> <span class="c-product-price-value">{value.productDisplayGrid.salePrice}</span></p> :
                                            value && value.productDisplayGrid && value.productDisplayGrid.itemPrice && value.productDisplayGrid.itemPrice != "$0.00" ? <p className="my-0 c-product-price">{value && value.productDisplayGrid.itemPrice ? value.productDisplayGrid.itemPrice : ""}</p> : ""}
                                            {value && value.productDisplayGrid && value.productDisplayGrid.priceRangeForFamily && value.productDisplayGrid.priceRangeForFamily.itemPrice ? <p className="my-0 c-product-price">{value && value.productDisplayGrid.priceRangeForFamily && value.productDisplayGrid.priceRangeForFamily.itemPrice}</p> : ""}
                                            {value && value.productDisplayGrid && value.productDisplayGrid.retailPrice && value.productDisplayGrid.retailPrice != "$0.00" ?
                                                <p class="c-retail-label">
                                                    {`Retail `}
                                                    <del><span>{value && value.productDisplayGrid && value.productDisplayGrid.retailPrice != "$0.00"}</span></del>
                                                </p> : value?.productDisplayGrid?.priceRangeForFamily?.retailPrice && value?.productDisplayGrid?.priceRangeForFamily?.retailPrice != "$0.00" ? <p class="c-retail-label">
                                                            {`Retail `}
                                                            <del><span>{value.productDisplayGrid.priceRangeForFamily.retailPrice}</span></del>
                                                        </p>:""}
                                        </>}
                                        {value.productDisplayGrid && value.productDisplayGrid.reviewURLAverage ?
                                            <div className="c-product-rating">

                                                <img loading="lazy" src={domainNameRef.current.concat(`/images/stars/50/rating-${value.productDisplayGrid.reviewURLAverage}_50.png`)} alt="rating" />

                                            </div> : ""}

                                            {value.productDisplayGrid && value.productDisplayGrid.hidePrice && value.productDisplayGrid.hidePrice == "false" && value.productDisplayGrid.qtyDiscountAvailable && value.productDisplayGrid.qtyDiscountAvailable == true || value?.productDisplayGrid?.priceRangeForFamily?.qtyDiscount == true ?
                                            <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
                                        <p id="recommendedQuickView" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></p>
                                        <button className='btn quick-btn modal-link' onClick={() => handleQuickViewProductPage(value.productDisplayGrid && value.productDisplayGrid.productId, value.productDisplayGrid && value.productDisplayGrid.activeFlagCount)}>Quick View</button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    </Carousel>}
            </div> : ""}
        </div>
    )
}

export default TeacherResourcesCarousel